import styled from 'styled-components';
import { BodyText } from './Text';

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const StyledCheckbox = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${(props) => (props.checked ? '#2c2c6c' : '#ccc')};
  background: ${(props) => (props.checked ? '#2c2c6c' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;

  &:after {
    content: '';
    display: ${(props) => (props.checked ? 'block' : 'none')};
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 2px;
  }
`;

const Checkbox = ({ checked, onChange, label }) => {
  return (
    <CheckboxContainer>
      <HiddenCheckbox checked={checked} onChange={onChange} />
      <StyledCheckbox checked={checked} />
      {label && <BodyText margin='0 0 0 10px'>{label}</BodyText>}
    </CheckboxContainer>
  );
};

export default Checkbox;
